// Role-based access control mirroring the logistics-quest-3 mobile app.
// Gestor (and equivalents) = full access.
// Administrativo (funcionário administrativo) = restricted access.
//
// In the logistics-quest-3 database, administrative staff are stored as
// role="funcionario" with category="administrativo" (drivers are role="entregador",
// managers are role="gestor"). We accept either signal.

const GESTOR_ROLES = ["gestor", "administrador", "admin", "owner", "gerente", "dono"];
const ADMINISTRATIVO_ROLES = ["funcionario", "funcionário", "administrativo", "administrative", "adm"];

const norm = (v) => String(v || "").toLowerCase().trim();

export const userKind = (user) => {
  const r = norm(user?.role);
  const cat = norm(user?.category);
  if (GESTOR_ROLES.includes(r)) return "gestor";
  if (ADMINISTRATIVO_ROLES.includes(r) || cat === "administrativo") return "administrativo";
  return null;
};

export const isApproved = (user) => {
  const s = norm(user?.approval_status);
  return s === "" || s === "approved";
};

export const isAllowedUser = (user) => userKind(user) !== null && isApproved(user);

// Role-only helper (kept for convenience / login pre-check).
export const isAllowedRole = (role) => userKind({ role }) !== null;

export const isGestor = (user) => userKind(user) === "gestor";
export const isAdministrativo = (user) => userKind(user) === "administrativo";

export const roleLabel = (userOrRole) => {
  const user = typeof userOrRole === "string" ? { role: userOrRole } : userOrRole || {};
  const kind = userKind(user);
  if (kind === "administrativo") return "Administrativo";
  if (kind === "gestor") return user.role ? String(user.role) : "Gestor";
  return String(user.role || "");
};

// Sections the Administrativo profile may access. Everything else is Gestor-only.
const ADMINISTRATIVO_SECTIONS = [
  "/dashboard",
  "/auditoria-km",
  "/auditoria-entregas",
  "/ponto",
  "/contador-horas",
  "/estoque",
  "/bases",
  "/historico",
];

export const canAccessSection = (user, to) => {
  if (isGestor(user)) return true;
  if (isAdministrativo(user)) return ADMINISTRATIVO_SECTIONS.includes(to);
  return false;
};

// Feature-level permissions inside sections that both profiles can open.
const ADMINISTRATIVO_FEATURES = {
  beneficios_config: false, // "Regras & Configurações" de Benefícios
  bases_manage: false, // criar/editar/excluir bases (administrativo só visualiza)
};

export const can = (user, feature) => {
  if (isGestor(user)) return true;
  if (!isAdministrativo(user)) return false;
  return ADMINISTRATIVO_FEATURES[feature] ?? false;
};
